// extracted by mini-css-extract-plugin
export var active = "_mq-2";
export var recordingDot = "_mq-1";
export var recordingIndicator = "_mq-0";